import vi from './__vi';
import ja from './__ja';

export default {
    vi
    ,ja
}